import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowsHide: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrows-hide, collapse, minimize"><path d="M8 4.75H2.75V19.25H8" stroke="currentColor" strokeWidth="1.5"/><path d="M16 4.75H21.25V19.25H16" stroke="currentColor" strokeWidth="1.5"/><path d="M9 16.75L12 13.75L15 16.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12 21V14.5" stroke="currentColor" strokeWidth="1.5"/><path d="M15 7.25L12 10.25L9 7.25" stroke="currentColor" strokeWidth="1.5"/><path d="M12 9.5V3" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconArrowsHide;
